export const MY_ACCOUNT_NODE_API = {
  editProfileAPI: '/api/my-account/edit-profile',
  updateEmailAPI: '/api/my-account/updateEmail'
};
